export enum TournamentDifficulty {
  GENERAL = 'GENERAL',
  BEGINNER = 'BEGINNER',
  ADVANCED = 'ADVANCED',
  ALL = 'ALL'
}

export type TournamentDifficultyWithoutAll = Exclude<TournamentDifficulty, 'ALL'>
